export enum CampaignValidationStatusEnum {
    PENDING = 'pending',
    REJECTED = 'rejected',
    APPROVED = 'approved',
}
